import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchCampaigns } from '../../lib/api';

export function useCampaigns(constituencyId) {
  return useQuery({
    queryKey: queryKeys.campaigns(constituencyId),
    queryFn: () => fetchCampaigns(constituencyId),
    enabled: !!constituencyId,
  });
}
